export const SET_USER = 'SET_USER'
export const SET_BUSY = 'SET_BUSY'
export const SET_ERROR = 'SET_ERROR'

export interface AuthState {
    busy: boolean
    user: unknown | null
    error: string | null
}

interface SetUserAction {
    type: typeof SET_USER
    user: unknown
}

interface SetBusyAction {
    type: typeof SET_BUSY
    busy: boolean
}

interface SetErrorAction {
    type: typeof SET_ERROR
    error: string | null
}

type AuthAction = SetUserAction | SetBusyAction | SetErrorAction

/**
 * Set user into store
 */
function setUser(state: AuthState, user: unknown): AuthState {
    return {
        ...state,
        user: user,
    }
}

/**
 * Set busy auth
 */
function setBusyAuth(state: AuthState, busy: boolean): AuthState {
    return {
        ...state,
        busy: busy,
    }
}

/**
 * Set error to auth
 */
function setErrorAuth(state: AuthState, error: string | null): AuthState {
    return {
        ...state,
        error: error,
    }
}

/**
 * Reducer for auth object in store
 */
export default function reducer(state: AuthState = [] as unknown as AuthState, action: AuthAction): AuthState {
    switch (action.type) {
        case SET_USER: return setUser(state, action.user)
        case SET_BUSY: return setBusyAuth(state, action.busy)
        case SET_ERROR: return setErrorAuth(state, action.error)
        default: return state
    }
}
